import React, { ReactNode, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import { buildTenantTheme } from 'tenants/buildTenantTheme';
import { TenantConfig } from 'tenants/types';

type ThemeProps = {
  children: ReactNode;
  tenantConfig: TenantConfig;
};

const Theme = ({ children, tenantConfig }: ThemeProps) => {
  const theme = useMemo(() => buildTenantTheme(tenantConfig), [tenantConfig]);

  return (
    <MuiThemeProvider theme={theme}>
      {/* eslint-disable-next-line */}
      {/* @ts-ignore */}
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </MuiThemeProvider>
  );
};

export default Theme;
